import { ICourseListItem } from '@/interface/course'
import { get, post } from '../index'
import { BannerType, ICourseQueryCondition } from '~/typings/index'
import {
  getCertificationTypes
} from './certification'
import { IBannerListItem } from '@/interface'
import { createDefaultCondition } from '@/utils/moduleHooks/course'

export interface ICourseListData {
  rows: ICourseListItem[]
  total: number
}

const LIST_KIND_MAP = {
  0: '4',
  1: '3'
} as Record<string, BannerType>

export async function getCourseList (condition: ICourseQueryCondition): Promise<ICourseListData> {
  return await new Promise((resolve) => {
    get('/certification/release/course/page/list', {
      ...condition
    }).then(res => {
      resolve(res.data as ICourseListData)
    }).catch(() => {
      resolve({
        rows: [],
        total: 0
      } as ICourseListData)
    })
  })
}

export async function entroll (relationId: string, emailNotificationStatus?: string, courseType = '0') {
  return await post('/user/registration/addRegistration', {
    relationId,
    emailNotificationStatus,
    courseType
  })
}

export async function getRequirements () {
  return await Promise.resolve([
    { text: 'Compulsory', id: '1' },
    { text: 'Elective', id: '0' }
  ])
}

export async function getDetail (id: string, courseType = '0') {
  return await new Promise((resolve) => {
    get('/certification/release/course/detail', {
      id,
      courseType
    }).then(res => {
      resolve({
        courseDetail: res.data
      })
    }).catch(() => {
      resolve({
        courseDetail: {}
      })
    })
  })
}

// 获取评价内容
export async function getFeedback (
  relationType: number |string,
  relationId: number | string,
  courseType = '0'
) {
  return await post('/certification/evaluate/queryByUserId', {
    relationType,
    relationId,
    courseType
  })
}

const getCertificationTypesList = (certificationTypes: Record<string, []> = {}) => {
  const list = []
  for (const i in certificationTypes) {
    list.push(Object.assign({}, { typeName: i, subTypeName: certificationTypes[i] }))
  }
  return list
}

export const getCertificationSubTypes = (certificationTypes: Array<{ typeName: string, subTypeName: string[]}>, certificationType: string) => {
  let list = [] as string[]
  certificationTypes.forEach(el => {
    if (certificationType === '') {
      list = [...new Set(list.concat(el.subTypeName))]
      return
    }
    if (certificationType === el.typeName) {
      list = el.subTypeName
    }
  })
  return list
}

export async function getCoureListData (query: ICourseQueryCondition, isMobile: boolean) {
  const condition = {
    ...createDefaultCondition(isMobile),
    ...query
  }
  if (isMobile) {
    condition.pageSize = 5
  }
  return await new Promise((resolve) => {
    Promise.all([getCourseList(condition),
      getCertificationTypes(condition.kind || '1'),
      post('/certification/banner/release/query', { typeList: [LIST_KIND_MAP[condition.kind || '1']] })
    ]).then(result => {
      const courseList = result[0]
      const certificationTypes = getCertificationTypesList(result[1] as Record<string, []>)
      // const certificationTypes = result[1] as []
      const certificationSubTypes = getCertificationSubTypes(certificationTypes, condition.certificationTypeName || '')
      // const certificationSubTypes = getCertificationSubTypes(certificationTypes, condition.certificationTypeName)
      const banner = result[2].data ? (result[2].data as IBannerListItem[])[0] : {}
      resolve({
        courseList,
        certificationTypes,
        certificationSubTypes,
        condition,
        banner
      })
    }).catch(() => {
      resolve({
        courseList: [],
        certificationTypes: [],
        certificationSubTypes: [],
        condition,
        banner: {}
      })
    })
  })
}

export async function getVideoInfo (id: string, courseContentId: string, courseType = '0') {
  return await get('/certification/release/course/power/check', {
    id,
    courseContentId,
    courseType
  })
}

export async function saveVideoPalyProgress (
  releaseCourseId: string,
  releaseCourseContentId: string,
  payDuration: string,
  quizExist = '1'
) {
  return await post('/certification/release/course/reload', {
    releaseCourseId,
    releaseCourseContentId,
    payDuration,
    quizExist
  })
}

export async function updateNotificationStatus (releaseCourseId: number) {
  return await post('/user/course/process/updateNotificationStatus', {
    releaseCourseId,
    notificationStatus: '2'
  })
}
